







import { Component, Vue, Prop } from 'vue-property-decorator';
// Components
import QuoteDetails from '@/components/shipment/QuoteDetails.vue';
import PaymentTermsUpsert from '@/components/shipment/PaymentTermsUpsert.vue';
import gql from 'graphql-tag';
import FetchShipmentQuote from '@/graphql/queries/shipment/FetchShipmentQuote.gql';
// Types
import {
  fetchShipmentQuote_shipments
} from '@/types/graphql/schemaTypes';

@Component({
  apollo: {
    shipment: {
      query: FetchShipmentQuote,
      prefetch: true,
      variables() {
        return {
          shipmentArgs: {
            shipmentId: this.$route.params.id
          }
        };
      },
      update: data => data && data.shipments && data.shipments[0],
      fetchPolicy: 'network-only'
    }
  },
  components: {
    PaymentTermsUpsert,
    QuoteDetails
  }
})
export default class Quote extends Vue {
  public shipment: fetchShipmentQuote_shipments | null = null;
}
